module.exports = __webpack_public_path__ + "static/media/me3_carousel_RightArrow.0d9445ea.svg";